window.HorizontalAccordion = () => {
	return {
		active: null,
		height: null,
		ready: false,
		observer: null,
		init() {
			setTimeout(() => {
				// Each item renders its panel next to its title; collect them into the content column
				const panels = this.$refs.list.querySelectorAll('[data-hacc-panel]');
				panels.forEach((panel) => {
					panel.classList.remove('hidden');
					panel.classList.add('absolute', 'inset-x-0', 'top-0', 'opacity-0', 'pointer-events-none', 'transition-opacity', 'duration-150');
					this.$refs.panels.append(panel);
				});

				// Absolutely positioned panels don't size the column; track the open one instead
				this.observer = new ResizeObserver(() => this.measure());
				this.select(panels[0]?.dataset.haccPanel);
				requestAnimationFrame(() => (this.ready = true));
			}, 0);
		},
		select(id) {
			if (!id || !this.observer) return;
			this.active = id;
			this.$refs.panels.querySelectorAll('[data-hacc-panel]').forEach((panel) => {
				const open = panel.dataset.haccPanel === id;
				panel.classList.toggle('opacity-0', !open);
				panel.classList.toggle('pointer-events-none', !open);
				// Fade the old panel out before the new one fades in
				panel.classList.toggle('delay-150', open);
				panel.inert = !open;
			});
			this.observer.disconnect();
			this.observer.observe(this.panel());
			this.measure();
		},
		panel() {
			return this.$refs.panels.querySelector(`[data-hacc-panel="${this.active}"]`);
		},
		measure() {
			const panel = this.panel();
			if (panel) this.height = panel.offsetHeight;
		},
	};
};
